import Carousel from "react-multi-carousel";

const DepartmentCarousel = ({ data }) => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  return (
    <Carousel
      responsive={responsive}
      className="card-list"
      additionalTransfrom={0}
      arrows={false}
      autoPlay
      autoPlaySpeed={1000}
      draggable
      focusOnSelect={false}
      infinite
    >
      {data.map((item, index) => {
        return (
          <div className="department" key={index}>
            {item}
          </div>
        );
      })}
    </Carousel>
  );
};

export default DepartmentCarousel;
